import script from "./InspecaoSupervisaoEstabelecimentoItensB.vue?vue&type=script&setup=true&lang=js"
export * from "./InspecaoSupervisaoEstabelecimentoItensB.vue?vue&type=script&setup=true&lang=js"

import "./InspecaoSupervisaoEstabelecimentoItensB.vue?vue&type=style&index=0&id=3dffe28f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dffe28f"]])

export default __exports__